module.exports = __webpack_public_path__ + "img/C06TechRamShipChampion_ua.0fc91f72.webp";